import { VueRecaptchaPlugin } from 'vue-recaptcha';

/**
 * Replaces the Vue 2-only `@nuxtjs/recaptcha` module, which used to register
 * the global `<recaptcha>` component — see `components/ui/UiRecaptcha.vue`.
 *
 * The site key still comes from frontkit's runtime config (`RECAPTCHA_SITE_KEY`),
 * the same value frontkit's own `$recaptcha` wrapper reads. That wrapper stays
 * in place: `useForm()` resets the widget through it after every submit.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const { recaptcha } = useRuntimeConfig().public.frontkit;

  nuxtApp.vueApp.use(VueRecaptchaPlugin, { v2SiteKey: recaptcha?.siteKey });
});
